import { render, staticRenderFns } from "./banner-edit.vue?vue&type=template&id=fed25684&scoped=true"
import script from "./banner-edit.vue?vue&type=script&lang=js"
export * from "./banner-edit.vue?vue&type=script&lang=js"
import style0 from "./banner-edit.vue?vue&type=style&index=0&id=fed25684&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed25684",
  null
  
)

export default component.exports